import { defineComponent as _defineComponent } from 'vue'
import { IconWrapper, CavuButton } from 'ui-shared-components';
import IconAlert from 'libraries/@white-label-icon/icon-alert/src/lib/icon-alert.vue';
import IconLink from 'libraries/@white-label-icon/icon-link/src/lib/icon-link.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'travel-insurance-eligibility',
  setup(__props) {


return { __sfc: true,IconWrapper, IconAlert, IconLink }
}

})